var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var Specialist = createReactClass({
    mixins: [PureRenderMixin],

    handleSetDoctor: function(e){
        if(!this.props.token){
            this.props.handleSpecialistUnauthenticatedUser({
                actionFnName: 'setMySpecialist',
                actionFnParams: [this.props.specialist]
            });
            return;
        }

        this.props.setMySpecialist(this.props.specialist, this.props.token);
        this.handleClickTracking(e);
    },

    handleClearDoctor: function(e){
        this.props.clearMySpecialist(this.props.token);
        this.handleClickTracking(e);
    },

    handleClickTracking: function(e){
        this.props.clickTracking('Click', e.currentTarget.innerText);
    },

    render: function(){
        var phoneA;
        if(this.props.specialist.phone){
            phoneA = this.props.specialist.phone.split('|')[0];
        }

        return (
            <li className="specialist-item">
                <p className="name">{this.props.specialist.displayName}</p>
                {this.props.specialist.distance &&
                    <p className="distance"><span className="ion-navigate"></span>{this.props.specialist.distance} mil</p>
                }
                {this.props.specialist.subSpecialty &&
                    <p className="specialty">
                        <span className="specialty-item">{this.props.specialist.subSpecialty}</span>
                    </p>
                }
                <p className="address">
                    <span className="ion-ios-location-outline"></span>
                    <span className="street">{this.props.specialist.address.street}</span>
                    <span className="city">{`${this.props.specialist.address.city}, ${this.props.specialist.address.state || ''} ${this.props.specialist.address.postalCode || ''}`}</span>
                </p>
                {this.props.specialist.email &&
                    <p className="email"><span className="ion-ios-email-outline"></span>{this.props.specialist.email}</p>
                }
                <div className="action clearfix">
                    {this.props.isMySpecialist
                        ?
                        <button className="button success" type="button" onClick={this.handleClearDoctor} title="Selected"><span className="ion-android-done"></span><span className="show-for-medium">Selected</span></button>
                        :
                        <button className="button" type="button" onClick={this.handleSetDoctor} title="Select Doctor"><span className="ion-android-done"></span><span className="show-for-medium">Select Doctor</span></button>
                    }
                    {phoneA &&
                        <p className="phone">
                            <a className="button secondary hollow" href={'tel:' + phoneA} title={phoneA} onClick={this.handleClickTracking}><span className="ion-android-call"></span><span className="show-for-medium">{phoneA}</span></a>
                        </p>
                    }
                </div>
            </li>
        )
    }
});

module.exports = Specialist;



// WEBPACK FOOTER //
// ./src/common/routes/find-a-specialist/components/layout/specialist.jsx